module.exports = __webpack_public_path__ + "media/images/glyphicons-halflings-white-d763722113489a4bd9293d469ca9791f.png";